export const FETCH_CONFIGURATION_REQUEST = 'FETCH_CONFIGURATION_REQUEST';
export const FETCH_CONFIGURATION_FAIL = 'FETCH_CONFIGURATION_FAIL';

export const SET_COMMON_CONFIGURATION = 'SET_COMMON_CONFIGURATION';
